module.exports = __webpack_public_path__ + "img/pp-transparent.66573ee2.png";